// This is a UI prototype — appointment type/payment options and the availability
// lookups below are all mocked. They'll be replaced by real BFF-backed data once
// the booking flow's shape has settled.

export type AvailableDate = { value: string; label: string }
export type AvailableTime = { value: string; label: string }

export const MOCK_AVAILABLE_DATES: AvailableDate[] = [
  { value: "2026-07-06", label: "Monday, July 6" },
  { value: "2026-07-07", label: "Tuesday, July 7" },
  { value: "2026-07-08", label: "Wednesday, July 8" }
]

export const MOCK_AVAILABLE_TIMES: AvailableTime[] = [
  { value: "09:00", label: "9:00 AM" },
  { value: "10:30", label: "10:30 AM" },
  { value: "14:00", label: "2:00 PM" }
]

export const mockAppointmentTypeOptions = [
  { value: "initial", label: "Initial consult" },
  { value: "follow-up", label: "Follow-up consult" }
]

export const paymentMethodOptions = [
  { value: "insurance", label: "Bill insurance" },
  { value: "self-pay", label: "Self-pay" }
]

export const MOCK_PROVIDER = "Dr. Paul Turek, MD"
export const MOCK_PRICE = "$139.00"

export function findLabel(options: { value: string; label: string }[], value: string): string {
  return options.find((option) => option.value === value)?.label ?? value
}

export function fetchAvailableDates(): Promise<AvailableDate[]> {
  return new Promise((resolve) => setTimeout(() => resolve(MOCK_AVAILABLE_DATES), 600))
}

export function fetchAvailableTimes(_date: string): Promise<AvailableTime[]> {
  return new Promise((resolve) => setTimeout(() => resolve(MOCK_AVAILABLE_TIMES), 600))
}
